/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type HealthColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const HealthColorable = ({ color, ...props }: HealthColorableProps) => {
  const gradientId = useMemo(
    () => `health_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Health', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(5.9, 11.25)" stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" fill="none">
        <path d="M5.51469 14.8779C5.68718 15.1087 5.87249 15.332 6.07094 15.5465L6.92224 16.4697L17.5149 27.9531C17.9109 28.3824 18.589 28.3824 18.985 27.9531L29.5774 16.4697L30.428 15.5465C33.524 12.1913 33.524 6.74992 30.428 3.394L30.3123 3.2672C27.2167 -0.0890678 22.1969 -0.0890678 19.1013 3.2672L18.9855 3.39269C18.5894 3.82233 17.9108 3.82214 17.5148 3.39226L17.3996 3.2672C14.3036 -0.0890678 9.28392 -0.0890678 6.18791 3.2672L6.07094 3.394C4.52343 5.07196 3.75 7.27101 3.75 9.47041" />
        <path d="M23.75 11.7675H18.3737H15.4913C15.2996 11.7675 15.1247 11.8772 15.0412 12.0498L14.0545 14.0898C13.8534 14.5055 13.2444 14.4497 13.1222 14.0044L11.6547 8.65806C11.5276 8.19469 10.8837 8.15998 10.7074 8.60699L9.42267 11.8651C9.34734 12.0562 9.16287 12.1817 8.95752 12.1817H0.75" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="3" x2="44" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HealthColorable;
